<script setup lang="ts">
import type { UICarouselChipsMediaCardProps } from './UICarouselChipsMediaCard.props'

defineProps<UICarouselChipsMediaCardProps>()

const emit = defineEmits(['select'])
</script>

<template>
  <button
    v-bind="$attrs"
    class="group flex flex-col items-center gap-2.5"
    @click="emit('select')"
  >
    <div
      class="aspect-4/5 relative h-[105px] w-[84px] overflow-hidden"
      :class="{ 'border-stroke-primary border': chipSelected }"
    >
      <div class="h-full w-full object-cover object-top opacity-100">
        <UIMedia v-if="chip.media" :media="chip.media.media" />
      </div>
      <div
        v-if="chip.hoverMedia"
        class="hover-card absolute inset-0 h-full w-full object-cover object-top opacity-0 group-hover:opacity-100"
      >
        <UIMedia
          :media="chip.hoverMedia.media"
          class="h-full w-full object-cover object-top"
        />
      </div>
    </div>
    <div class="underline-effect-appear max-w-full">
      <p
        class="text-light-7 text-effect text-text-primary hyphens-auto break-words pb-1 text-center"
      >
        <span>
          {{ chip.label }}
        </span>
        <span> ({{ count }}) </span>
      </p>
    </div>
  </button>
</template>
<style scoped lang="scss">
.hover-card {
  transition: opacity 0.4s ease;
}
</style>
